import { styled } from "@mui/material/styles"
import { TextField } from "@mui/material"

const StyledTextField = styled(TextField)(() => ({
  "& .MuiOutlinedInput-notchedOutline legend": { display: "none" },
}))

export { StyledTextField }
